import Chart from 'chart.js/auto';
window.application.register("draw-chart", 
	class extends Stimulus.Controller {
		static get targets() {
		  return [ "canvas","minDate","maxDate" ]
		}

		connect(){
			this.element[this.identifier] = this;
			this.dataset = [];


			var a = JSON.parse(this.data.get('dataset'));
			//only show data after 2016
			// var b = a.map(data => {
			// 	return {
			// 		x: moment(data.date, 'YYYY-MM-DD').valueOf(),
			// 		y: parseFloat(data.price)
			// 	}
			// });
			this.dataset = a;
			// console.log(this.dataset)
			this.render();
		}

		render(){
			
			var dataset = this.dataset;
			// console.log(dataset.length);
			if(this.chart){
				// this.chart.data.labels = [dataset[0].x, dataset[dataset.length-1].x];
				// this.chart.data.datasets[0].data = dataset;
				// this.chart.update();
			}else{
				// console.log(dataset.length);

				// console.log("ASDASDSADASDASD");
				var datasets = [];
				var xAxisLabels = [];
				for(let index in this.dataset){
					if(index > 0){
						var dataset = {
							label: this.dataset[index][0],
					    	pointRadius: 4,
					    	borderWidth: 2,
						}
						if(index == 1){
							dataset.borderColor = dataset.pointBackgroundColor = '#00bea0';
							dataset.borderWidth = 0;
							dataset.fill = '+2';
						}else if(index == 2){
							dataset.borderColor = dataset.pointBackgroundColor = '#ed7632';
						}else{
							dataset.borderWidth = 0;
							dataset.borderColor = dataset.pointBackgroundColor = '#ffd050';
						}
						dataset.data = [];
						for(let indexB in this.dataset[index]){
							// if(indexB > 0){
								dataset.data.push(parseFloat(this.dataset[index][indexB].replace('%','')));
							// }
						}

						dataset.data.push(null);
						datasets.push(dataset);
					}else{
						for(let indexB in this.dataset[index]){;
							if(indexB > 0 && this.dataset[index][indexB].split(' ').join('').length > 0){
								xAxisLabels.push(this.dataset[index][indexB])
							}else if(indexB == 0){
								xAxisLabels.push(this.dataset[index][indexB])
							}
						}
						xAxisLabels.push(null);
					}
				}
				this.chart = new Chart(this.canvasTarget.getContext('2d'), {
		    		type: 'line',
					data: {
						labels: xAxisLabels,
					    datasets: datasets
					},
					options: {
						responsive: true,
						maintainAspectRatio: true,
						aspectRatio: 2,
						interaction: {
					      mode: 'index',
					      intersect: false,
					    },
						plugins:{
							legend: {
								display: false,
							},
							tooltip:{
								callbacks:{
									label: function(tooltipItem) {
				                        return tooltipItem.dataset.label + '   ' + tooltipItem.formattedValue + ' %'
				                    }
								}
							}
						},
						scales:{
							y:{
								type:'linear',
								ticks:{
									callback: function(val, index) {
										// Hide the label of every 2nd dataset
										return this.getLabelForValue(val) + '%';
									},
								}
							}
						},
					    animation:true
					}
				});
			}
		}

		disconnect(){
			try{this.tearDown()}catch(err){};
		}

		tearDown(){
			// this.element.innerHTML = '';
		}
	}
)